<template>
  <div :class="`q-pa-sm flex row rounded-borders bg-${variant}-light`">
    <div class="q-mr-sm">
      <QIcon :name="fullVariant.icon" :color="variant" size="24px" />
    </div>
    <div class="col row items-center">
      <p class="text-body1">
        <slot />
      </p>
    </div>
  </div>
</template>

<script>
import { QIcon } from 'quasar';

const variants = {
  info: { icon: 'eva-info-outline' },
  negative: { icon: 'eva-alert-triangle-outline' },
  positive: { icon: 'eva-checkmark-circle-2-outline' },
  warning: { icon: 'eva-alert-circle-outline' }
};

export default {
  name: 'SAIMessage',
  props: {
    variant: {
      type: String,
      default: 'positive',
      validator: (value) => Object.keys(variants).indexOf(value) > -1
    }
  },
  computed: {
    fullVariant() {
      return variants[this.variant];
    }
  },
  components: {
    QIcon
  }
};
</script>
